exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#About[data-page=faq] .content_title{margin-bottom:20px}#About .main{background:#fff}#About .main .main_inner .main_section.section_about{padding:50px 0 60px;background:-webkit-gradient(linear,left top,left bottom,from(#eef1f6),to(rgba(238,241,246,0)));background:linear-gradient(180deg,#eef1f6,rgba(238,241,246,0))}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/usr/src/nuxt-app/assets","/static":"/usr/src/nuxt-app/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-237aa020","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./pages/faq/index.vue
// module id = UJ5H
// module chunks = 5